var map = {
	"./Education.svg": 6504,
	"./Employment.svg": 3236,
	"./Health Care.svg": 5379,
	"./Home Repair.svg": 6698,
	"./Household.svg": 1065,
	"./Housing.svg": 4527,
	"./Technology.svg": 5296,
	"./Transportation.svg": 2012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2422;